module.exports = __webpack_public_path__ + "img/W7014-trad.a2ff2a45.jpg";